import { LOCALE_STORAGE_KEY } from '@/lib/constants';
import type { Locale } from '@/lib/platformTypes';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type LocaleStore = {
	locale?: Locale;
	setLocale: (locale: Locale) => void;
	clearLocale: () => void;
};

export const useLocaleStore = create<LocaleStore>()(
	persist(
		(set) => ({
			setLocale: (locale) => set({ locale }),
			clearLocale: () => set({ locale: undefined }),
		}),
		{
			name: LOCALE_STORAGE_KEY,
			partialize: (state) => ({ locale: state.locale }),
		},
	),
);
